import React, { useState } from "react";

import { loader } from "../..";
import { useSelector } from "react-redux";
import { showToast } from "../../utils/showToast";

interface LocationSelectProp {
  extraStyles?: string;
  handleSelectLocation?: (lat: number, lng: number, loc: string) => void;
  showMap?: boolean;
  mapId: string;
  inputId: string;
  divId?: string;
  prefillLocation?: string;
  useVehicleLocation?: boolean;
}
const LocationSelect: React.FC<LocationSelectProp> = ({
  extraStyles,
  handleSelectLocation,
  showMap = true,
  mapId,
  inputId,
  divId,
  prefillLocation,
  useVehicleLocation,
}) => {
  const [location, setLocation] = useState<{
    lat: number | undefined;
    lng: number | undefined;
  }>({ lat: 0, lng: 0 } as { lat: number; lng: number });

  const [places, setPlaces] = useState<google.maps.places.PlaceResult>(
    {} as google.maps.places.PlaceResult
  );

  const [placeholder, setPlaceholder] = useState<string>("");

  const addVehicle = useSelector((state: any) => state.addVehicle.Vehicle[0]);

  // const loader = new Loader({
  //   apiKey: process.env.REACT_APP_GOOGLE_MAPS_API_KEY as string,
  //   version: "weekly",
  //   // libraries: ["places"],
  // });
  let map: google.maps.Map;

  if (showMap) {
    loader.importLibrary("maps").then((google) => {
      // const map = new google.Map(document.getElementById("map") as HTMLElement, {
      //   center: { lat: -33.8688, lng: 151.2195 },
      //   zoom: 13,
      // });

      map = new google.Map(document.getElementById("map") as HTMLElement, {
        zoom: location.lat ? 13 : 4,
        center: {
          lat: location.lat ? location.lat : 39.8283,
          lng: location.lng ? location.lng : -98.5795,
        },
        mapId: mapId ?? "map",
      });
    });
  }

  loader.importLibrary("places").then((google) => {
    const options = {
      // bounds: defaultBounds,
      componentRestrictions: { country: "us" },
      // fields: ["address_components", "geometry", "icon", "name"],
      strictBounds: true,
    };
    // const autocomplete = new google.Autocomplete(
    //   document.getElementById(`${inputId}`) as HTMLInputElement,
    //   options
    // );

    const inputElement = document.getElementById(
      `${inputId}`
    ) as HTMLInputElement;

    // const placeService = new google.PlacesService(map);
    // // console.log(placeService);
    // let result: google.maps.places.PlaceResult[] = [];

    // placeService.nearbySearch(
    //   {
    //     location: { lat: 40.7128, lng: -79.006 },
    //     radius: 38624.16,
    //     type: "parking",
    //   },
    //   (results, status, pagination) => {
    //     // console.log(pagination?.hasNextPage);

    //     if (results?.length) {
    //       // result?.push(...results);
    //       result = [...result, ...results];
    //       // console.log(result?.length);
    //       if (pagination?.hasNextPage) {
    //         pagination.nextPage();
    //       } else {
    //         // console.log(result?.length);
    //         // return result;
    //       }
    //     }
    //     if (result.length) {
    //       placeService.getDetails(
    //         { placeId: result[0].place_id as string },
    //         (place, status) => {
    //           console.log("result 0", result[0]);
    //           console.log("place", place);
    //           console.log("status", status);
    //         }
    //       );
    //     }

    //     const postalCodes = result.map((place) => {
    //       // console.log("place", place);

    //       const postalCodeComponent = place.address_components?.find(
    //         (component) => component.types.includes("postal_code")
    //       );
    //       // console.log("postalCodeComponent", postalCodeComponent);

    //       return postalCodeComponent ? postalCodeComponent.long_name : "";
    //     });

    //     const uniquePostalCodes = Array.from(new Set(postalCodes));

    //     const filteredPostalCode = uniquePostalCodes.filter(
    //       (code) => code !== ""
    //     );

    //     console.log("filteredPostalCode", filteredPostalCode);

    //     return filteredPostalCode;

    //     // console.log(results?.length);
    //   }
    // );

    const autocomplete = new google.Autocomplete(inputElement, options);

    inputElement?.addEventListener("keydown", (event) => {
      if (event.key === "Enter") {
        event.preventDefault();
      }
    });

    autocomplete.addListener("place_changed", () => {
      const place = autocomplete.getPlace();

      if (!place.geometry) return;

      setPlaces(place);

      const lat = place.geometry?.location?.lat();
      const lng = place.geometry?.location?.lng();

      setLocation({ lat, lng });

      if (handleSelectLocation) {
        handleSelectLocation(
          lat as number,
          lng as number,
          place.formatted_address as string
        );
      }
    });
  });

  if (location.lat && location.lng) {
    loader.importLibrary("marker").then((google) => {
      const marker = new google.AdvancedMarkerElement({
        position: {
          lat: location.lat as number,
          lng: location.lng as number,
        },
        map: map,
        title: places.formatted_address,

        zIndex: 999,
      });
    });
  }

  // const { isLoaded } = useJsApiLoader({
  //   id: "google-map-script",
  //   googleMapsApiKey: process.env.REACT_APP_GOOGLE_MAPS_API_KEY as string,
  //   libraries: ["places"],
  // });
  const [address, setAddress] = useState<google.maps.places.PlaceResult>();
  const [addressRef, setAddressRef] = useState<google.maps.places.SearchBox>();
  const onLoad = (ref: google.maps.places.SearchBox) => setAddressRef(ref);

  const onPickupChanged = () => {
    if (addressRef) {
      const places = addressRef.getPlaces();
      if (places) {
        console.log(places[0]);
        setAddress(places[0]);
      }
    }
  };

  const handleUseVehicleLocation = () => {
    if (!addVehicle?.vehicleLocation)
      return showToast("Vehicle location not found", "error");

    const { longitude, latitude, location } = addVehicle?.vehicleLocation;

    if (!longitude || !latitude || !location) return;

    setPlaceholder(location);
    setLocation({ lat: latitude, lng: longitude });

    if (handleSelectLocation) {
      handleSelectLocation(
        latitude as number,
        longitude as number,
        location as string
      );
    }
  };

  // console.log(placeholder, prefillLocation);
  return (
    <div className="w-full h-full flex flex-col gap-5">
      {
        //@ts-ignore
      }
      <div
        className={`w-full flex flex-col md:flex-row border h-12 border-darkGreen rounded-md ${
          useVehicleLocation ? "p-0.5" : ""
        }`}
      >
        <input
          className={`outline-none flex-1  w-full rounded-md px-4 text-sm text-midGreen ${extraStyles} `}
          id={`${inputId}`}
          // value={prefillLocation ?? undefined}
          placeholder={
            placeholder
              ? placeholder
              : prefillLocation
              ? prefillLocation
              : "Enter a location"
          }
        />
        {useVehicleLocation && (
          <button
            type="button"
            onClick={handleUseVehicleLocation}
            className="p-2 border rounded-md text-white bg-midGreen/90 hover:bg-darkGreen "
          >
            Use Vehicle Location
          </button>
        )}
      </div>
      {showMap && (
        <div
          className="h-[500px] w-full border border-darkGreen rounded-md"
          id="map"
        ></div>
      )}

      {/* <StandaloneSearchBox
        onLoad={onLoad}
        onPlacesChanged={onPickupChanged}
        bounds={
          new google.maps.LatLngBounds(
            new google.maps.LatLng(49.906404, -5.744317),
            new google.maps.LatLng(55.722192, 2.340094)
          )
        }
      >
        <input
          className={`outline-none border border-darkGreen w-full h-12 rounded-md px-4 py-2 text-sm text-midGreen ${extraStyles}`}
          // id={`${inputId}`}
          placeholder="Enter a location"
        />
      </StandaloneSearchBox> */}
    </div>
  );
};

export default LocationSelect;
